import { useMemo } from "react";
import { usePrintFileFormat } from "./usePrintFileFormat";
import { usePrintInput } from "./usePrintInput";
import { usePrintTask } from "./usePrintTask";

export const usePrint = () => {
  const printFileFormat = usePrintFileFormat();
  const printInfo = usePrintInput(printFileFormat);
  const { startPrint, loading, printResult } = usePrintTask(printInfo);

  return useMemo(() => ({ startPrint, loading, printResult }), [startPrint, loading, printResult]);
};
